import styled from 'styled-components';

export default styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
